import { CContainer } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { IDiagnoseMessage, IPoolInfo, IPoolMappingEntry, IX3AdminViewModel } from '../abstraction';
import { KPoolList, KPoolMapping } from '../components';
import { dispatcher, securitySvc } from '../Karma';

interface IProps {
}

interface IState {
	model: IX3AdminViewModel;
	poolList: IPoolInfo[];
	mappings: IPoolMappingEntry[];
	messages: IDiagnoseMessage[];
	pools: string[];
}

// Pages d'administration des pools x3
// 
export class X3Admin extends React.Component<IProps, IState> {
	static URL: string = "/X3Admin/";

	public constructor(props: any) {
		super(props);

		this.state = {
			model: null,
			poolList: [],
			messages: [],
			mappings: [],
			pools:[],
		};
	}

	componentDidMount = () => {
		this.loadMappings().then(() => {
			this.loadPoolList();
		});
	}

	// Charge la liste de les pools
	loadPoolList = () => {
		dispatcher.getPoolList().then((result) => {
			this.setState({ poolList: result })
			this.forceUpdate();

		})
	}

	// Charge la liste des mapping WS<>Pool
	loadMappings = async () => {
		dispatcher.getX3AdminViewModel().then((cfg) => {
			if (cfg.poolMapping == null) cfg.poolMapping = [];
			if (cfg.pools == null) cfg.pools = [];
			this.setState({ mappings: cfg.poolMapping });
			this.setState({ pools: cfg.pools });
			this.forceUpdate();
		});
	}

	// clic sur bouton de d�marrage de pool
	onStartPoolClick = async (poolId: string) => {
		let result = await dispatcher.startPool(poolId);

		if (result)
			this.updatePoolInfo(result.poolInfo);

		result.messages.map(x => this.state.messages.push(x));

		this.setState({
			messages: this.state.messages
		})

		this.loadPoolList();
	}

	// clic sur bouton de d�marrage de pool
	onStopPoolClick = async (poolId: string) => {
		let result = await dispatcher.stopPool(poolId);

		if (result)
			this.updatePoolInfo(result.poolInfo);

		result.messages.map(x => this.state.messages.push(x));

		this.setState({
			messages: this.state.messages
		})

		this.loadPoolList();
	}

	// Mise � jour des information du pool concern�
	private updatePoolInfo = (pool: IPoolInfo) => {
		var row = this.state.poolList.filter(r => r.poolId == pool.poolId)[0];

		if (row) {
			row.autoStart = pool.autoStart;
			row.autoStartDisabled = pool.autoStartDisabled;
			row.initSize = pool.initSize;
			row.lifeTimeout = pool.lifeTimeout;
			row.maxSize = pool.maxSize;
			row.unusedTimeout = pool.unusedTimeout;
		}
	}

	//#region Rendus

	render() {
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>

		return (
			<CContainer>
				<div className="X3Admin">
					<KPoolList rows={this.state.poolList} onStartPoolClick={this.onStartPoolClick} onStopPoolClick={this.onStopPoolClick} />
					<KPoolMapping saveProvider={dispatcher} msgboxProvider={dispatcher} availablePools={this.state.poolList} pools={this.state.pools} mappings={this.state.mappings} />
				</div>
			</CContainer>
		);
	}

	//#endregion 
}
